const commonWolof = {
    aboutPage: {
        futureSection: {
            description:
                'AUTO24.{{ Country_cctld }} muusul dëkk bu jëkk – dëkk bi lañu jëkk ci alal ci yëg, ci satisfaksyoŋu kliyaaŋ, ak ci m ër u oto. Ci fokkusu ci ndimbal kliyaaŋ ñi ngir ñu def desisi yoŋ wu ñuul, nu ngi ree definisi yoon wi {{ Country_people_indication }} ñi jënd ak joxe oto yooyu ñu yore. Jot ci ñaari àllarba ñi ñuwi jëfandikoo jënd oto ci yoon wu rafet.',
            description2:
                'AUTO24.{{ Country_cctld }} - Calité Sertifié, Yëg Bu Joxe',
            title: 'Waxxiku Oto Yooyu Ñu Yore ci Afrik'
        },
        heroDescription:
            'AUTO24.{{ Country_cctld }} mooy tàggu yëg wu {{ Country_name }} ngir oto yooyu ñu yore ñu sertifié, mu jëm kanam ci kontinong bi njiitu njiir bi nekk ci oto yooyu ñu yore yu bari mark. Missiyoŋ wi nu ngi jëfandikoo mooy soppi leeraay bi ñu jënd oto ak calité, xamle, ak yëg. Waan jënd oto ju njëkk walla soppi, nu ngi joxe platforom bu yëg ak fasilité nekk ci biir.',
        heroTitle: 'Foo Calité Ak Yëg Jokk',
        welcomeToAuto24: 'Dalal Jàmm ci AUTO24',
        whyTrustUsSection: {
            description: 'Nu ngi wéy di joxe oto – nu ngi joxe jàmm yu am solo',
            pointsDescription:
                'Nu ngi wéy di joxe oto – nu ngi joxe jàmm yu am solo.',
            pointsDescription1:
                'Oto bu nekk ñu sukk ci tàngal ak teknisyen ñu sertifié, jàmmte ak calité bu biir.',
            pointsDescription2a:
                'Politis bu Dellu ci Ñeenti Ayu Bis – Amul satisfaksyoŋ? Dellu ko ci ñeenti ayu bis.',
            pointsDescription2b:
                'Garanti bu Juróom Ñaar i Ayu – Standard ci oto yooyu ñu sertifié.',
            pointsDescription2c:
                'Pake asuraŋs ak antretyen bu ñatt i at – Waxxikoo bu amul tànk ci bi ji ëkk.',
            pointsDescription3:
                'Dokument yooyu ñu yore ak oto yépp ñu sukk ci tàngal ngir xamle lëgal ak mekanik.',
            pointsDescription4:
                'Yoon wu yomb ngir joxe walla soppi oto bi ak takkusu calité.',
            pointsTitle: 'Lu Tax Ñaari Àllarba Yëg AUTO24',
            pointsTitle1: 'Sukk Oto ci 120 Pwaŋ',
            pointsTitle2: 'Inyans yooyu Ñu Yëg Kliyaaŋ',
            pointsTitle3: 'Dokument Yooyu Ñu Sukk',
            pointsTitle4: 'Joxe ak Soppi Bu Yomb ak Bu Jàmm',
            title: 'Lu Tax Ñaari Àllarba Yëg AUTO24'
        }
    },
    browseCars: {
        buttonText: 'Xool Oto Yépp',
        description:
            'Xool oto yooyu ñu yore ñu sertifié yu ñu bari calité ci {{ Country_name }} – ñu sukk calité, ñu am asuraŋs bu yépp, ak ñu jàpp ngir yoon.',
        title: 'Gis Oto Bu Ñuul Ngir Yaw Loo Ci'
    },
    and: 'and',
    or: 'or',
    buy: 'Jënd',
    sell: 'Jaay',
    send: 'Yonee',
    finance: 'Finance',
    about: 'About',
    blogs: 'Dibéeral',
    blog: 'Blog',
    tools: 'Ay jëfandikoo',
    callUsAt: 'Wooñu ci',
    signIn: 'Connectéwu',
    signUp: 'Bindu',
    insure: 'Assurer',
    cancel: 'Baayi',
    search: 'Seet',
    enteremailAddress: 'Dugëlële sa adresse email',
    enterPassword: 'Dugël mot de passe',
    enterFullName: 'Bindële sa tur yëp',
    tellUsYourFullName: 'Bindal nu sa tur bu yàgg',
    tellUsYourEmailAddress: 'Bindal nu sa adresse email',
    emailAddress: 'Adresse email',
    mobileNumber: 'Número bi',
    tellUsWhatYouWant: 'Bindal nu lu ngay soxla nga jëfandikoo',
    sendEnquiry: 'YÓNEE JËF JËL',
    referralSubmitted: 'Referral bi ñu yónnee! Jërejëf ci referral bi.',
    enterEmailToGetResetLinkInfo:
        'Dugëlële sa email bi andak sa compte ñu mën la yoone email ak ay tektal nguir nga réinitialiser sa mot de passe',
    enterOldPassword: 'Dugëlële sa mot de passe bu yagg',
    enterPrice: 'Bindal sa njëg',
    callBackSubtitle:
        "Enter your name and phone number we'll get back to you soon",
    pleaseEnterFullName: 'Please Enter Full Name',
    pleaseprovideusyourdetails: 'Baal ñu nga jox ñu sey détails',
    pleaseprovideusyourcardetails: 'Baal ñu nga jox ñu sey détayu auto',
    desiredPleaseprovideusyourcardetails:
        'Baal ñu nga wax ñu détayu auto bi nga bëgg, tannale lumu neew neew ben.',
    enterCarDetails: 'Enter Car Details',
    pleaseInputYourName: 'Please input your Name!',
    pleaseInputYourEmail: 'Please input your Email Address!',
    pleaseInputValidEmail: 'Baal ñu nga dugël adress email bu jak!',
    pleaseInputYourPassword: 'Please input your password!',
    pleaseInputYourPhoneNumber: 'Please input your Phone number!',
    rememberMe: 'Fattelikuma',
    forgotPassword: 'Forgot Password',
    carsAvailable: 'Autos yi am jamono ji',
    termOfUse: 'Ngir liggéey bi',
    privacyPolicy: 'Lu neex kat',
    alreadyhaveanAccount: 'Already have an account?',
    howItWorks: 'Numuy doxe',
    howtoBuy: 'Nuñuy jënde',
    howtoSell: 'Nuñuy jaaye',
    exploreBlogs: 'Wërële blogs yi',
    car: 'Car',
    Certified: 'Yuñu woolu',
    Inspected: 'Yuñu seytu',
    petrol: 'Essence',
    hybrid: 'Hybrid',
    carburant: 'Carburant',
    phev: 'PHEV',
    ev: 'Electric',
    automatic: 'Automatic',
    phonenumberisnotvalid: 'Phone number is not valid',
    internalError: 'Erreuru biit, baal ñu nga jeemat wala nga diokko ak ñune',
    knowaboutyourcarbetterandgetevaluation:
        'Know about your car better and get valuation for a better deal.',
    cardetailssendSuccessfully: 'Car details sent sucessfully',
    thanyouforprovidingusdetail:
        'Thank you for provding us the details. We will give you a call back soon.',
    selectbrand: 'Select a brand',
    selectcountry: 'Select country',
    enterMileage: 'Enter Mileage',
    minMileage: 'Minimum Mileage',
    maxMileage: 'Maximum Mileage',
    selectmodel: 'Select a model',
    selectYear: 'Tannale att',
    selectorenterbrand: 'Select or enter a brand',
    selectorentermodel: 'Select or enter a model',
    selectorenterbodyType: 'Select or enter a body type',
    brand: 'Marque',
    model: 'Modèle',
    modelYear: 'Attu modèle',
    selectFuelType: 'Tannale zenru essence bi',
    selectACondition: 'Tannale condition',
    phoneNumber: 'Numéro téléphone',
    phonePlaceholder: 'Enter your phone number',
    loanTitle: 'Deñuley jox njëg wi gën, am si intérêt 10%',
    loanHappyCusSubtitle:
        'Suñu mbekte ay cliane luñu soxale la moñuy doolele ñuy jooxe yeneeni ndimbële',
    loanButton: 'Calculer sama abb bi',
    calculateButton: 'Ñëb',
    blogTitle: 'Xoolale balla nguey jënd auto',
    blogSubtitle:
        'Yii ñoy mbirr yi nga wara xam balla nguey jënd beep xeetu auto ',
    viewAllCars: 'View All Cars',
    viewAllResultsFor: 'Wàcc ci ñaari njaxal yi',
    availableNowOn: 'Amena legui ci',
    account: 'Akawnt',
    myAccount: 'My Account',
    ourBrands: 'Suñuy marques',
    contactUs: 'Nuy jaaye',
    contactInformation: 'Coordonnées',
    aboutUs: `À propos`,
    addressLine: 'Address Line',
    contact: 'Contact',
    whyChooseAuto: 'Why Choose AUTO24?',
    allcarshavebeenthoroughlyinspectedandreconditionedHowweguaranteecarquality:
        'All cars have been thoroughly inspected and reconditioned. How we guarantee car quality',
    imInterested: "I'm interested",
    buyOnline: 'Buy Online',
    downPayment: 'Acompte',
    hotDeal: 'Hot deal',
    lowPrice: 'Low price',
    likeNew: 'Like new',
    moneybackSubtitle: "You don't like the car? We refund you",
    warrentyTitle: 'Guarantie 6 wer',
    warrentySubtitle:
        'Extendable to 12 months on engine, gearbox and powertrain',
    inspectionPointsSubtitle:
        'Inspected by our team of auto experts on all angles',
    roadSideAssistanceTitle: '1 year assistance',
    roadSideAssistanceSubtitle:
        'Roadside assistance included on all our vehicles, for one year',
    deliveryTitle: 'Home delivery',
    deliverySubtitle: 'We can deliver your car anywhere in Senegal',
    xDeliverySubtitle: 'We can deliver your car anywhere in {{country}}',
    Summary: 'Summary',
    engine: 'Engine',
    enginePower: 'Engine Power',
    fuelType: 'Fuel Type',
    buildYear: 'At tabax',
    bodyType: 'Mello yaram',
    numberofkeys: 'Number of keys',
    exteriorColor: 'Exterior Color',
    interiorColor: 'Interior Color',
    driveTrain: 'Transmission',
    engineSize: 'Engine size',
    fiscalPower: 'Fiscal power',
    specifications: 'Specifications',
    specification: 'Màndarga yi',
    lengthWidthHeight: 'Length,Width & Height',
    weight: 'weight',
    emissionCO2: 'Emission CO2',
    fuelConsumption: 'Fuel Consumption',
    enginepower: 'Engine Power',
    fuelTankCapacity: 'Fuel Tank Capacity',
    'performance&Economy': 'Dolle & ndincc',
    features: 'Features',
    'weight&Dimensions': 'Weight & Dimensions',
    showMoreFeatures: 'Show More Features',
    showLess: 'Show Less',
    serviceHistory: 'Service History',
    whyAUTO24: 'Why AUTO24',
    serviceCenter: 'Service Center',
    Kilometers: 'Km',
    lookingForaCarQtellUs: 'Auto nguey wêr? Wax ñu!',
    sellPageTitle: 'Jaayale sa auto ci ñaari étapes yu yomb',
    sellPageSubtitle:
        'Mën nga joxe sey détayu auto dineñula wowat pour yeneeni détails',
    findCarPricePageTitle: 'Find The Price of Your Car',
    findCarPricePageSubtitle:
        'You can provide details about your car and we will call you back for futher deals.',
    whyFinanceYourCarwithAuto24: 'Lutax nga wara financer sa auto ak AUTO24',
    financeSubtitle:
        'Deñuley jox offru financement yi gën andak intérêts yu neew ak ay acomptes',
    competitiveRates: 'Njëg yu gën yenen yi ',
    competitiveDesc: 'APR from 5% (indicative)',
    competitiveDescMA: 'Mën nañu leble te doo fay ci ay sart',
    flexiableDuration: 'Ay diir yu yollom',
    flexiableDes: 'Feyale sa auto ci ay versements yu 12 wala 72 weer',
    Percent100OnlineApproach: 'Approche 100% ci ligne bi',
    Percent100OnlineApproachDesc: 'Sign all you documents at home',
    loanCalculatorTitle: 'Nattukaayu allu auto bi',
    loadCalculatorSubtitle:
        'Njëggu intérêt par weer bi dafey wuute ndax deñuy liguey ak këri finance yu wuute',
    interestRate: 'Njëggu intérêt',
    years: 'years',
    ourFinancingPartners: 'Ñiñuy andale ci wallum finance',
    ourInsurePartners: 'Ñiñuy andale ci wallum assurance',
    ourPartners: 'Our Partners',
    copyrightfooter: 'Copyright Â© Africar Group Pty Ltd - All rights reserved',
    insureSubtitle: 'Beggele ci politiqu assurance bi gën ci njëk bi gën',
    aboutFinanceSub: 'Ñii ñen la ci ñiñuy andale ci wallum finance',
    selectMileageRange: 'Tannale gammu kilométrage bi',
    selectTransmissionType: 'Tannale typu transmission bi',
    backToHome: 'Dellu kër gua',
    getACallBack: 'Amal ñu woowat la',
    personalDetails: 'Sey détayu bop',
    carDetails: 'Détayu auto',
    ourBrandsSubtitle:
        'Marques yi gëna makk leñu lëkëlole yi am ay raaya yu bëri ndax liguey bu ame solo',
    ourTeam: 'Jëfandikoo bi',
    findCarPrice: 'Jàllugaañul bu noppu',
    teamMembers: 'Xale yi',
    ourTeamSubtitle: 'Xam ñu bu bax ci suñu xalaatu ikip yi',
    latestPosts: 'Mbind yi muj',
    lastestPostSubtitle: 'Lii blogs yi muj la ci ay seetkat yu wuute',
    featuredPosts: 'Mbind yi siiw',
    featuredPostSubtitle: 'Lii blogs yi gënë siiw la ci ay seetkat yu wuute',
    newsLetterTitle: 'Bula ben leep raw',
    newsLetterSubtitle:
        'Bindule ci blogu AUTO24 nguir wëy di jot bep xibaar ci wallum autos',
    buySellTitle: 'Pare nga?',
    buySellSubtitle:
        "Whether it's selling your used car or buying your next ride, we can do it all.",
    sellYourCar: 'Jaayale sa auto',
    buyaCar: 'Jënd auto',
    footerInfo:
        "AUTO24.ci ben filiale la bu Africar Group Pty Ltd, ñu bind ko ci Côte d'Ivoire ci turru l'IDU CI-2022-0027564 O.\n",
    FAQ: 'FAQ',
    buyCars: 'Jënd ay autos',
    sellCars: 'Jaay ay autos',
    categories: 'Catégories',
    topStories: 'Xibaar yi ci kaw',
    donthaveanaccount: "Don't have an account",
    resetPassword: 'Réinitialiser mot de passe bi',
    editProfile: 'Tëggaat sa profil',
    createNewPassword: 'Fintale mot de passe bu bess',
    passwordresetsuccessfully: 'Password reset successfully',
    passwordisRequired: 'Password is required!',
    minimum8chars: 'Minimum 8 characters are required',
    usersuccessfullyregistered: 'User successfully registered !',
    shortBio: 'As tuut ci yaw',
    Save: 'Enregistrer',
    Share: 'Seddale',
    delete: 'Tecc',
    saveChanges: 'Save Changes?',
    youcanstillchangetheseinformation: 'Ba legui mën nga sopi sey information',
    changessavedsuccessfully: 'Sopiku enregistré wu neñu ak jam',
    yourchangessavedsuccessfully: 'Sa sopiku yi enregistré wu neñu ak jam',
    deleteyourAccount: 'Tecc sa compte?',
    deleteAccountsubtitile:
        'Once you delete your account your all data will be lost and you cant  get access to your account.',
    accountdeletedsuccessfully: 'Compte bi tediuna ak jam',
    youcanstillexpolrecarwithouthavinganaccount:
        'Mën nga wëy di djiss autos yi nga ame compte am deet',
    logout: 'Deconnectéwu',
    sortBy: 'Sort By:',
    filterBy: 'Filter By:',
    lowestPriceFirst: 'Njëg wu gëna neew ci kaw',
    highestMileageFirst: 'Highest Mileage First',
    lowestMileageFirst: 'Lowest Mileage First',
    price: 'price',
    mileage: 'Mileage',
    selectBodyType: 'Tannale mello yaram bi',
    filter: 'Filters',
    moreFilters: 'Yeneen filtres',
    color: 'Culoor',
    transmission: 'Transmission',
    highestPriceFirst: 'Highest Price First',
    provideUsYourDetail: 'Provide Us Your Detail',
    interestcartitle: 'Da nga am yeene jënd auto bii?',
    interestcarsubtitle:
        'Tannale ben option, yeneen yi dineñu wëy di feñ ci sey limu jënd',
    bookThisCar: 'Denclu auto bii',
    bookThisCarSubtitle:
        'Doxal fii ngir\nnuñu joxal {{Price}} {{ Currency }}, nuñu dëkk oto bi ayu-benn, rekk yaw',
    scheduleAVisit: 'Jappale kañ ngey setsi',
    scheduleAVisitSubtitle:
        'Demale ci suñu bitik nguir djiss auto bi nga bëg. Dafey wëy di jappandi ci yenen jënd kat yi',
    popularblog: 'Blogs yi gëna siiw',
    popularblogSub: 'Here are Popular blogs from different users',
    category: 'Catégorie',
    carOverview: 'Car Overview',
    Detailssentsuccessfully: 'Details sent successfully',
    DetailChangeSubtitle:
        'Thank you for providing us your details. We will give you a call back soon.',
    continue: 'Yeggali',
    carnotfoundSubtitle:
        'Ben auto amule ci fane yi nga tanne. Dimbëliñu ci sey détails ba noppi ñu dimbêli la nga djiss auto bi nga yellole.',
    logoutModelTitle: 'Woor nala ni danga bëgë decconectéwu?',
    french: 'French',
    QuickLinks: 'Liens yu gaaw',
    similarResults: 'Similar Results ',
    copyrightInfo:
        "AUTO24.CI is a subsidiary of Africar Group Pty Ltd, registered under the unique identification number CI-2022-0027564 O in the Republic of Cote d'Ivoire",
    recentlyAdded: 'Yiñu yokk bu yaagule',
    recentlyAddedSubtitle:
        'Fii mën nga fe jiss autos yu wuute yuñu yokk bu yaagule',
    newCarList: 'Ñaay auto bi fenn',
    newCarListSubtitle: 'Ci, defar yi dafa wone ñaay auto bi juulit',
    electricCarList: `Ñaay ñettali ñaari`,
    electricCarListSubtitle: `Ci, defar yi dafa wone ñaay auto bi eléktrik`,
    importedCarList: `Ñaay auto bi neexkatulu`,
    importedCarListSubtitle: `Ci, defar yi dafa wone ñaay auto bi ñuy saxar`,
    cheapestCarList: 'Ñaay auto bi du {{X}}',
    cheapestCarListSubtitle:
        ' Ci, defar yi dafa wone ñaay auto bëg benn xarale {{X}} ak ñu',
    hereyoucanseedifferentsimilarcars:
        'Here you can see different similar cars',
    carNotFound: 'Djissuñu auto bi',
    whatsappUrlText: 'Hello! I am interested in this car',
    latestService: 'Latest Service',
    resetSuccessMsg:
        'Now you can sign in with your new password or you can still explore cars',
    bothPasswordMustMatch: 'Both passwords must match',
    mustBeAtleast8Characters: 'Must be at least 8 characters',
    sendResetLink: 'Yoonema lien réinitialisation',
    returnTo: 'Return to',
    resetPasswordModalTitle: 'Are you sure you want reset your password?',
    yourPasswordChangedSuccessfully: 'Sa mot de passe bi sopi nga ko ak jam',
    confirmPassword: 'Confirm Password',
    shortDescription: 'Melokaan bu gatt',
    carImages: 'Nataalu autos',
    uploadImage: 'Upload Image',
    browse: 'Browse',
    listAnother: 'Lister benen',
    listCarRequestSentSucessfully: 'List Car Request Sent Successfully',
    basicDetails: 'Détails yu yemamaay yi',
    manual: 'Manual',
    postYouHaveLiked: 'Mbind yi nga bëgg',
    enterNewPassword: 'Mot de passe bu bess',
    confirmNewPassword: 'Confirmele sa mot de passe bu bess',
    passwordChangeSuccessfully: 'Mot de passe bi sopeku na ak jam',
    verificationTitle:
        'We have sent you a verification link to you email address',
    viewLink: 'Xol lien bi',
    resendingLink: 'Yonnee lien',
    tokenExpired: 'Your token is expired please create new one',
    tokenExpiredTitle: 'Account Verification Link Expired',
    provideUsYourDetails: 'Provide us Your Detail',
    diesel: 'Diesel',
    other: 'Other',
    showCars: 'Wanel autos',
    accountVerifiedSuccessfully: 'Compte bi seytu neñuko jaar na yoon',
    engineSound: 'Engine Sound',
    showAllImage: 'Wanee nataal yëp',
    ourBenefits: 'Suñuy avantages',
    inspectionPoints: '100 bërëbu seytukaay yu suñu ñi xarañ ci auto',
    warranties: '6 months warranty (engine,gearbox and axle)',
    maintenances: '1 year maintenance package with AUTO24.sn',
    assistance: 'Remorquage ak ndimbël ci frein ci diirup 12 weer',
    multiCurrency: 'Multi-currency payment FCFA, €, $, £',
    moneyBack: 'Guarantie wu dello xaliss ci 5 fan',
    financing: 'Financing ',
    dragAndDrop: 'Drag & drop image or',
    imageFormat: 'Supported formats: JPEG, PNG',
    sellNow: 'Jaay legui',
    confirm: 'Dëgële',
    didntFindQuestion: "Didn't find the question you're looking for?",
    yourMessage: 'Sa bataaxal',
    sendMessage: 'Send Message',
    loanTenure: 'Dirrub all bi',
    selectLoanTenure: 'Ndëddu Xalam Yoon',
    interestInput: 'Degg naata ci ({{X}} ak {{Y}})',
    months: 'Wer',
    from: 'From',
    upto: 'Upto',
    rateOfInterest: 'Taux wu intérêt',
    tenure: 'Mandat',
    monthlyEmi: 'EMI par weer',
    loadMore: 'Wannele lu ëp.',
    contactSubtitle: 'Da nga loy lacc ? Mën nga ñu yoonee bataaxal sayo bëgge',
    inspector: 'Inspecteur',
    inspectorSubtitle: 'Laccele ben inspecteur',
    insurance: 'Assurance',
    insuranceSubtitle: 'Laccele assurance bi gën',
    financeSubtitles: 'Laccele finance bi gën',
    diagnostic: 'Diagnostique',
    minPrice: 'Njëg wi gënë neew',
    maxPrice: 'Njëg wi ëp',
    minDistance: 'Sorriway bi gëna neew',
    maxDistance: 'Max Distance',
    min: 'Min',
    max: 'Max',
    diagonosticSubtitle: 'Laccele diagnostique',
    VINVerify: 'Vérifier VIN',
    VINVerifySubtitle: 'Laccele vérification VIN bu gaaw',
    learnMore: 'Xam lu ëpp',
    speedRegular: 'Speed Regulator',
    airCondition: 'Air Condition',
    sequential: 'Sequential',
    CDPlayer: 'CD Player',
    reversingCamera: 'Reversing Camera',
    reversingRadar: 'Reversing Radar',
    GPSNavigation: 'GPS Navigation',
    parkAssist: 'Park Assist',
    startAndStop: 'Start and Stop',
    airbag: 'Airbag',
    ABS: 'ABS',
    computer: 'Computer',
    rims: 'Rims',
    sunroof: 'Sun Roof',
    electricMirrors: 'Electric mirrors',
    electricWindows: 'Electric windows',
    dateFirstUse: 'Date first use',
    seats: 'Seats',
    certifiedUsedCars: 'Autos yu daw yuñu woolu',
    certifiedUsedCarsSubtitle: 'Jëndële autos yu daw ci kolute ak lu leer',
    inpectionsPoints: '100 bërëbu seytu',
    inpectionsPointsSubtitle: 'Suñu autos yëp leñu seytu bu baax',
    refundPolicy: 'Politiqu dello ci 5 fan',
    refundPolicySubtitle: "You don't like it, get refunded!",
    warrentySubtitles:
        'Moteur, boïtu vitesse ak groupe motopropulseur, guarantie 6 wer',
    excellentCondition: 'Excellent condition',
    goodCondition: 'Good condition',
    averageCondition: 'Average condition',
    damagedCar: 'Damaged car',
    lessThan10: 'Less than 10 000 Km',
    moreThan100: 'More than 100 000 Km',
    serviceTitle: 'Jënd wala jaay? Mën neñula dimbëli',
    serviceSubtitle:
        'Explore our services and make your car buying / selling experience seamless ',
    verifyAccount: 'Seytu compte',
    verifyNumber: 'Seytu numero',
    didntGetTheCode: "Didn't get the code?",
    resendCode: 'Re-send code',
    bluetooth: 'Bluetooth',
    home: 'Kër gua',
    lookingForBestInsurance: 'Assurance bi gën nguey sett?',
    ourCustomerRepresentativesWillGetBackInTouchWithYou:
        'Ñifi teewale suñuy cliane dineñula woowat.',
    upload: 'Upload',
    profileUpload: 'Dugële nataal bu bess',
    remove: 'Dindi',
    number: 'Number',
    backToCarDetail: 'Back To Detail Page',
    backToTheCarDescription: 'Back to the car description',
    backToTheCarListing: 'Back To Car Listing',
    phoneVerifiedSuccesfully: 'Phone Verified successfully',
    signWithPhone: 'Sign in with Phone',
    signWithEmail: 'Sign in with Email',
    newPriceFrom: 'New Car Price From',
    theySpeakAboutUs: 'Ñu ngui wax ci ñune',
    theySpeakAboutUsSubTitle:
        'Ben séléctionwu pressu aduna bi di wax ci AUTO24',
    carLoanSubTitle: 'Fey par weer bimu nara doone',
    carLoanTotalRepayment: 'Total Repayment Amount',
    forgotTokenExpired: 'Password Reset Link is Expired',
    discover: 'Discover the car',
    paperWork: 'Vehicles paperwork are up to date and verified',
    verifyhistory: 'We verify history of all the vehicles we buy',
    buyBack: 'We buy back your old car',
    additionalPhotos: 'Additional Photos',
    inspectionReports: 'Rapport yi ci xool',
    referenceLink: 'Lien ci yëngu',
    technicalVisit: 'Technical visit certificate',
    keysPhotos: 'Keys photo',
    seeKeyPhotos: 'See the photo',
    pleaseTryAfterSomeTime: 'Please try after some time',
    favourites: 'Yiñu gëna bëgg',
    electric: 'Electric',
    autonomy: 'Autonomy',
    productionYear: 'Production Year',
    payWithOtherCurrencytitle: 'Pay in an other currency with AUTO24',
    payWithOtherCurrencySubtitle:
        'With AUTO24, you can pay on one of our international bank accounts in any of the currencies below. Here is the price you would need to transfer.',
    convertedPrice: 'Converted Price',
    favouritesNotFoundSubtitle:
        "You haven't added any cars to favourites. Explore cars and add your favourites",
    noFavouritesFound: 'No Favourites Found',
    frontCrankOilSeal: 'Front crank oil seal',
    engineOverHaul: 'Engine overhaul',
    rearCrankOilSeal: 'Rear crank oil seal',
    engineTuneUp: 'Engine tune up',
    engineMount: 'Engine Mount',
    oilPanGasket: 'Oil Pan Gasket',
    valveCoverGasket: 'Valve cover gasket',
    oilFilterBracketOring: 'Oil filter bracket oring',
    intakeManifoldGasket: 'Intake Manifold Gasket',
    waterLeak: 'Water leak',
    radiator: 'Radiator',
    engineTimingCoverGasket: 'Engine Timing Cover Gasket',
    waterPump: 'Water Pump',
    belts: 'Belts',
    fuelFilter: 'Fuel Filter',
    airFilter: 'Air Filter',
    underChassis: 'Under Chassis',
    tieRod: 'Tie Rod',
    ballJointLandR: 'Ball Joint L&R',
    idlerArm: 'idler Arm',
    pitmanArm: 'Pitman Arm',
    steeringPump: 'Steering Pump',
    steeringHoses: 'Steering Hoses',
    steeringBox: 'Steering Box',
    steeringRackAndPinion: 'Steering Rack & Pinion',
    frontShockLandR: 'Front Shock L&R',
    rearShockLandR: 'Rear Shock L&R',
    stabilizerLinkage: 'Stabilizer Linkage',
    crossJointPropellerShaft: 'Cross Joint Propeller Shaft',
    upperArmBushing: 'Upper Arm Bushing',
    rearLowerArmBushing: 'Rear Lower Arm Bushing',
    suspensionSpring: 'Suspension Spring',
    breakSystem: 'Break System',
    brakePad: 'Brake Pad',
    brakeDiscRotor: 'Brake Disc Rotor',
    wheelBearing: 'wheel Bearing',
    brakeMasterCLY: 'Brake Master CLY',
    backBooster: 'Back Booster',
    brakeWheelCall: 'Brake Wheel Call',
    handBrakeCable: 'Hand Brake Cable',
    brakeHoses: 'Brake Hoses',
    rearAxlesAndDriveShafts: 'Rear Axles & Drive Shafts',
    frontAxle: 'Front Axle',
    rearAxle: 'Rear Axle',
    axleDifference: 'Axle Difference',
    differenceFrontOrRear: 'Difference Front Or Rear',
    axleSealFrontOrRear: 'Axle Seal Front Or Rear',
    oilPumpGasket: 'Oil Pump Gasket',
    frontOilSeal: 'Front Oil Seal',
    rearOilSeal: 'Rear Oil Seal',
    transmissionMount: 'Transmission Mount',
    gearStickSouta: 'Gear Stick Souta',
    oilCollerPipe: 'Oil Cooler Pipe',
    gearPerformance: 'Gear Performance',
    liquidSystem: 'Liquid System',
    engineOil: 'Engine Oil',
    transmissionOil: 'Transmission Oil',
    brakeFluid: 'Brake Fluid',
    engineCoolant: 'Engine Coolant',
    washerFluid: 'Washer Fluid',
    electricitySystem: 'Electricity System',
    battery: 'Battery',
    alternator: 'Alternator',
    starler: 'Starler',
    lights: 'Lights',
    ac: 'A/C',
    centerLock: 'Center Lock',
    wiperBlades: 'Wiper Blades',
    troubleCode: 'Trouble Code',
    computerCods: 'Computer Cods',
    acCondensor: 'A/C Condenser',
    acRadiator: 'A/C Radiator',
    interior: 'Interior',
    seatAndBelts: 'Seats And Belts',
    interiorControlsAndSwitches: 'Interior Controls And Switches',
    sunRoofAndWindows: 'Sun Roof And Windows',
    fuelAndTemperatureGauge: 'Fuel And Temperature Gauge',
    dashboardAndGauges: 'Dashboard And Gauges',
    radioOrMusicSystem: 'Radio Or Music System',
    sRSAirbags: 'SRS Airbags',
    steeringWheelTiltOrlock: 'Steering Wheel Tilt Or Lock',
    mirrors: 'Mirrors',
    bodyInspection: 'Body Inspection',
    inspectionDate: 'Inspection Date',
    carInspectionReport: 'Car Inspection Report',
    showPicture: 'Show Picture',
    pageNotFound: 'Page Not Found',
    pageRemoved: "This page doesn't exist or was removed!",
    askQuestionOnWhatsapp: 'Questions? Ask us on whatsapp!',
    whatsappsPlaceholder: 'Ask anything!',
    customerSupport: 'Customer Support',
    needHelpChatWithUs: 'Need Help? Chat with us on Whatsapp',
    instaTitle: 'Topp ñu ci Instagram',
    instaSubTitle:
        'Jottale suñu offres yu muj, ay produits ak suñuy xibaar ci sassi!',
    questionSentSuccessfully: 'Yonee nga lacc yi ak jam',
    questionSentSuccessfullySubtitle:
        'Your question has been sent successfully. We will get back to you for your answer',
    unSubscribeMessage:
        'You have been successfully unsubscribed from the Auto24 Blogs.',
    numberMustBeUnique: 'Number must be unique',
    saving: 'Saving',
    sending: 'Sending',
    signingIn: 'Signing In',
    signingUp: 'Signing Up',
    loggingout: 'Logging out',
    deleting: 'Deleting',
    querySubmittedSuccessfully: 'Query submitted successfully',
    somethingWentWrong: 'Something went wrong!',
    removedFromWishlist: 'Removed from wishlist !!',
    addedToWishlist: 'Added to wishlist !!',
    subscribedSuccessfully: 'Subscribed successfully',
    alreadySubscribed: 'Already subscribed',
    messageIsRequired: 'Message is required',
    fullName: 'Full Name',
    email: 'Email',
    message: 'Bataaxal',
    queries: 'Laay',
    feedback: 'Xalaat',
    queriesDescription:
        'Am nga laay ci seen wotoom yoonem ? Noo fi nekk ngir ñu jëkkëloo seen laay yoonem.',
    feedbackDescription:
        'Waxal ñu seen xel. Seen xalaat day ñu jëkkëloo ngir ñu gënn ñëpp seen sërrvîis.',
    getInTouchWithUs: 'Jokkoo ak ñu',
    phoneNumberVerifiedSuccess:
        'Phone number verified successfully, Please login.',
    accountVerifiedSuccessfullySubtitle:
        'Your account has been verified successfully. Do you want to login?',
    phoneVerifiedSubtitle:
        'Your phone number has been verified successfully. Do you want to login',
    doyouwantDeleteAccount: 'Danga bëga dindi sa compte ap diir?',
    verifyEmail:
        'Baal ñu nga settaat sa email ci Auto24. Yonee neñula ben lien nguir nga seytuwat ko ci sa email.',
    betweenXAndY: 'Between {{X}} and {{Y}} km',
    xIsrequired: '{{name}} is required',
    xInspectionPoints: '{{number}} inspection points',
    xlistingPageResultTitle: '{{number}} Cars Found',
    xlistingPageResultsTitle: '{{number}} Cars Found',
    carViewsXTimes: 'Viewed {{number}} times today',
    maximumXdigitsisallowed: 'Maximum {{X}} digits is allowed',
    minimumXdigit: 'Minimum {{X}} digits is allowed',
    byClickingXButton: 'By clicking {{name}} Button, you agree to our',
    otpVerificationSubtitle:
        'Enter the 5 digit code sent to {{code}} {{number}}',
    otpVerificationEmail: 'Enter the 5 digit code sent to {{email}}',
    sold: 'Jaay',
    new: 'New',
    used: 'Benn',
    popular: 'Nuyoo',
    makes: 'Yenn',
    carTypes: 'Noon nax',
    explore: 'Jàngal',
    followUS: 'Sooñu',
    none: 'None',
    all: 'All',
    discount: 'Discount',
    careers: 'Kër mu neex',
    year: 'Year {{X}} and above',
    discountOff: '{{X}} Remise',
    financeYourCarWith: 'Finance Your Car With',
    creditButton: 'CREDIT GRATUIT',
    loanPaymentSimulator: 'Kalkilateuru jumtuka caaraan',
    loanPaymentContent:
        ' Nuñu defe ko yomb nga am caaraan bi nga bëgg. Ngen ñu la jappale ci génne jumtuka, dale ko ci défar jëfandikukat yi ba gis ngir fekk ndombu jumtuka bu yéeme.',
    loanCalculatorContent:
        'Tolluwaayu intere weer wu nekk mën na wuute ndax danuy liggéeyandoo ak yenn institision finansieer yu wuute.',
    vehiclePrice: 'Vehicle price',
    noOfMonthlyPayments: 'Number of monthly payments',
    monthlyPaymentAmount: 'Monthly payment amount',
    creditRequestedAmount: 'Credit Requested Amount',
    overallCostOfCredit: 'Jumtuka jéggi',
    simulatorContribution: 'Simulator contribution',
    percentageOfContribution: 'Percentage of contribution',
    applicationFees: 'Application fees',
    monthlyInsurance: 'Monthly insurance',
    noOfOwners: 'Number Of Owners',
    condition: 'Condition',
    maisonMere: 'Maison Mere',
    imported: 'Imported',
    tamperedOdometer: 'Tampered Odometer',
    carIssue: 'Car Issues',
    evaluateAgain: 'Evaluate Again',
    marketValue: 'Market Value',
    downloadAuto24App: `Deejerul App Auto24`,
    browseMore: `Wara, jeuk, ak neex - sa yoon motor mbaajji xam xam`,
    saveTimeAndEffort: 'Bersaaw Waktu Ak Jëm',
    saveTimeAndEffortSubtitle:
        'Defaralu yàlla, dem yàlla fii nit, mu doxal yàlla bët, noppalu jokk na sant a yépp',
    freeNoCost: 'Jaamul Moytu Ndax Kuwotlu',
    freeNoCostSubtitle: `Féegulñu kuutunxu, féebulñu, kanamul ñoon axtuna, ak prosesuna bi - mu fii ngir wuut`,
    competetivePrice: 'Xamu Am Këyit',
    competetivePriceSubtitle:
        'Mbaa defar noppalu mu ngir daf mbaa; mu feccikelu nitulñu ju ñëwlañu ak dëggëti wut',
    carTitle: `Sumbu Jiit`,
    carDesc: `Dafay neñ benn sumbu jiit`,
    personalDetail: `Sumbu Nataal`,
    personalDetailDesc: `Dafay neñ benn sumbu nataal`,
    sellCarHere: `Jëmm Leen Jiit`,
    sellCarHereDesc: `Nga def njëm, am baat yi nga len sumbu jiit`,
    buySellUsedCar: `Jëfë ak jàppale ci biir naari tappal lu`,
    pressPage: {
        title: 'Auto24 Press',
        description1: 'Auto24 am na solo ci ay media wuute wuute ci àdduna.',
        description2:
            'Auto24 itam fekk na ci konferãns yi ci Paris/Faraans, Lisbon/Portugaal, Barcelona/Españ, Sydney/Ostaraali, London/UK, Kigali/Rwanda, Bangkok/Tayiland, Abidjan/Kot diwaar, Johannesburg/Afrik di Sid, Dakar/Senegaal, Nairobi/Kenya, Casablanca/Marok…'
    },
    auto24Press: `Auto24 Umurongo`,
    auto24PressDesc1: `Auto24 yavutse mu birori by'ibitaramo birimo igisobanuro mu byanditse n'abandi.`,
    auto24PressDesc2: `Auto24 yatangije kwandikwa mu mikorere ibiri hagati y'abanyamahanga mu Mujyi wa Paris/France, Lisbon/Portugal, Barcelona/Spain, Sydney/Australia, London/UK, Kigali/Rwanda, Bangkok/Thailand, Abidjan/Ivory Coast, Johannesburg/South Africa, Dakar/Senegal, Nairobi/Kenya, Casablanca/Morocco…`,
    mediaExposure: `Amul yoonu laaftu bi`,
    mediaExposureDesc: `Neexu daa faw mu yoonu laaftu bi`,
    press: `Benno`,
    enterValidPhoneNumber: 'Nëkk natalu nataalul way',
    sellCar: 'Jox oto',
    findUsGoogle: 'Séén leen ci Google Map',
    locateUs: 'Waajal nu',
    whereFindUs: 'Fan nga bés nu?',
    aroundLocationText: 'Danga nu gis ci këru yii',
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'Tiktok',
    twitter: 'Twitter',
    youtube: 'Youtube',
    linkedin: 'LinkedIn',
    heroTitle:
        'Yoon bu gëna gaaw te yomb ci <yellow>Jënd</yellow> ak <green>Jaay</green> Alxuraan yi',
    caRefundPolicy: 'Polisi bu ñaari-alal',
    caRefundPlicyDesc:
        'Delloo saxul seen xaalis. Doxantu leen sax bu yéenul yéexal.',
    caWarranty: 'Jëmbët',
    caWarrantyDesc: 'Jëmbët bu 6 weer. Nga nooy, sa alxuraan dañ ko dajale.',
    caInspectedDesc: 'Leeralal bu mat. Seetlu na ko ndombo yu xam-xamkat yi.',
    login: 'Sàjj',
    wantToSellYourCar: 'Damaa bëgg jàpp sa alxuraan?',
    findUs: 'Séénu bës',
    featuredCars: 'Oto yuñ fësal',
    exploreCarByBodyType: 'Saytu oto ci xeetu yaram',
    searchByBrands: 'Seet ci màrk yi',
    loanSubtitle:
        'Danuy bàyyi xel ci sunuy kiliyaan bi ak seen bànne/ex, te loolu moo nuy ñaax nu yokk sunuy serwiis',
    perfectMatchYourBudget: 'Dafa méngoo bu baax ak sa poos',
    sellYourVehicle: 'Bëgg nga jaay sa oto?',
    sellYourVehicleSubtitle:
        'Danuy bàyyi xel ci sunuy kiliyaan bi ak seen bànneex, te loolu moo nuy ñaax nu yokk sunuy serwiis',
    sellMyCar: 'Jaay sama oto',
    blogTitleMobile: 'Xoolal balaa ngay jënd',
    blogSubtitleMobile: 'Li mujjee jàng ci auto24',
    readMore: 'Leer ci',
    opps: 'Ops!',
    noCarSection: 'Daa melni amul benn limu ci wàll wii. Bëgg nga laaj oto?',
    requestCar: 'Laaj oto',
    submitRequestFormSubtitle:
        'Yonneel ab laaj, dina ñu la jàppale nga am oto bu méngoo ak sa soxla.',
    requestCarPageTitle: 'Gis leen Oto bi nga doon wër',
    requestCarPageSubtitle:
        'Waxñu linga taamu, sunu ekip dina liggéey ngir wut li gën ci yaw. Yonneel sa laaj tay ngir gëna jege dawal oto bi nga bëgg.',
    viewAll: 'Xool lépp',
    inspection100: '100+ point yi car experts sunu di doxal',
    sixMonthWarranty:
        'Jàmmu mekaaniku bu amee ay weer 6 ci ñépp ay pàrti yu dul mottlu ci doxalin ak jàmm.',
    twoCarMaintenance: 'Maintenance ñaar yi Auto24 di def ci at bu nekk',
    towingAndBreakdownAssistance:
        'Assistance di lu ñu bëg ci lu ñu raxas ci 12 mois',
    multiCurrencyPayment: 'Jumtay multi-monnaie ak FCFA, €, $, £',
    fiveDaysMoneyBack: 'Lakki xaalis ci 5 jours',
    vehiclesPaperWork: 'Dokument yi vehicules am yi di yoon nga di doxal',
    verifyHistory: 'Historique yi sunu xeex ci ñi nga jënd xeet yi',
    buyBackOldCar: 'Jënd na sunu garage',
    aboutCar: 'lu jëm ci oto',
    overview: 'Résumé',
    carLoan: 'Leble oto',
    cars: 'Oto',
    note: 'Bind',
    yourEstimatedMonthlyPayment: 'Li nga xayma ni ngay fay weer wu nekk',
    applyFilter: 'Jëfandikool segg',
    clearAll: 'fomp lépp',
    carsUnderPriceDescription:
        'Auto24 mooy sa buntu bees ngir xool ay turu auto yu bari ci àddina si. Bu fekkee dama la soxla auto bu ndaw ngir dëkk, SUV bu wa kër am, walla sedan bu seer, sunu platform dina la jàppale ak ay jëmmu auto yu nekk ci lo soxla ak lo bëgg. Bëkk-nañu auto yépp ci Auto24 ci seen ñoñ ak seen matukaay, seen teknoloj, ak seen yërmande, ngir may la mënal ci sa wut auto bu wóor.',
    fuelPriceTracker: 'Suivi bu prix yi essence',
    fuelPriceTrackerDesc:
        'Gis gis ci njëg yi essence ak sunu jumtukaay bu yomb! Amal ay xibaar bu bees ci njëg yi essence ci sa zone, déggal ay prix yi ci ay station yu wuute, te seet lu gën rëy ci wàll bu njëg. Sàmmal sa xaalis te jël ay ndam ci sa yittewo. Kontrole sa njàngoro—gis njëg yi essence tey!',
    fuelPriceList: 'Liist bi jiitu ci mbir yi',
    lastUpdateDate: 'Bokk ci jamono ju ëpp ci wàll gi',
    electricityPriceTracker: 'Jëfandikukat Biir Ndamli',
    electricityPriceTrackerDesc:
        'Njit ndamli ci {{ Country_name }} dina yëngu ci ndogal, génnay ndamli, ak bes bu sell. Jëfandikukat Biir Ndamli jox na la xibaar bu yàgg ci ndogal yi ci Eskom ak ndamli, ngir nga man a doxal say njit bu rafet.',
    electricityPriceList: 'Ndamli Biir Li',
    currencyConverter: 'Jumtu Jëfandikukat Yoonu Lëkkale Xaalis',
    currencyConverterDesc:
        'Xam lii nga war a xam ci njumté lëkkale xaalis. Boo amee saytu, dem seen, wala dawal bopp ci Forex, lii dina la tax a jot bu baax.',
    liveExchangeRates: 'Njitu Lëkkale Xaalis Ci Géej Géej',
    updatedAsOf: 'Mis à jour le',
    kmToMi: 'Kilomèt ba Mile',
    miToKm: 'Mile ba Kilomèt',
    kmToMiConverter: 'Tool bu Ñu Jëmale Kilomèt ci Mile',
    miToKmConverter: 'Tool bu Ñu Jëmale Mile ci Kilomèt',
    distanceConverterDesc:
        'Jëmale ci yomb ak sañ-sañ mile ba kilomèt ak ci li ci des—mu nërmëtu ci safara, daw ak xaalis bu bees!',
    mile: 'Mile',
    kilometer: 'Kilomèt',
    howToConvert: 'Naka laa ko jëmale {{ unit }}?',
    benin: 'Benin',
    coteDIvora: "Côte d'Ivoire",
    kenya: 'Kenya',
    southAfrica: 'Afrig',
    morocco: 'Moroko',
    rwanda: 'Rwanda',
    senegal: 'Senegal',
    tanzania: 'Tanzania',
    togo: 'Togo',
    uganda: 'Uganda',
    vehicleTaxCalculator: 'Waññekaay galag u watiir',
    topCarSales: 'Watiir yu bees yi gëna jaay',
    drivingCostCalculator: 'Waññekaay njëgu watu',
    insuranceEstimator: 'Seetlukaay njëgu asuraas',
    carLoanCalculator: 'Waññekaay lebu watiir',
    exploreOtherTools: 'Wutal ay jumtuka yu nekk',
    drivingCostCalculatorDesc:
        'Xam njëriñ yi nga wara fay ngir dawal mooy lu am solo ci planing ak optimisation dépenses yi nga def ngir tukki. Boo demee liggéey bés bu nekk, walla nga dem tukki bu yagg ci auto, walla nga yor ay auto yu bari, sunu Calculateur bu Njëriñ yi Dawal dina la dimbali ngir estimer bu baax dépenses yi nga def ci carburant. Defal sa planing bi, comparé yoon yi, te jël decisions yu baax ci tukki bi ci lu yomb.',
    distance: 'Distance',
    fuelPrice: 'Prix carburant',
    enterFuelPrice: 'Dugalal prix carburant',
    fuelEconomy: 'Économie carburant',
    estimatedDrivingCost: 'Sa estimation bu coût dawal mooy',
    enterAllValues: 'Dugalal mboolem ay njëriñ ngir xayma',
    startAddress: 'Adres bu tàmbali',
    endAddress: 'Adres bu jeex',
    startAddressPlaceholder: 'Dugalal adres bu tàmbali',
    endAddressPlaceholder: 'Dugalal adres bu jeex',
    orEnterDistanceManually: 'Walla dugalal distans ak loxo',
    enterDistance: 'Dugalal distans',
    manualDistance: 'Distans ak loxo',
    calculatedFromAddresses: 'Xayma ci adres yi',
    priceUpdatedFromAPI:
        'Prix bi ñu defar ci xam-xam bu bees yi ci prix carburant',
    emissionEstimator: 'Waññikaay CO2',
    emissionEstimatorDesc:
        'Natt sa diggante ak mbir-àdduna te gis yoon yi ngay wàññi sa CO2 ci transport, jëfandikoo xargy ak sa jëf yi bés bu nekk. Saytu say jëf ngir dund gu yaatu te bokk ci def àdduna mu am wér.',
    estimatedEmission: 'Sa CO2 bi ñu xalaat mooy',
    emissionFactor: 'Faktëru CO2',
    efficiency: 'Njariñ',
    bestSellingCarsOfYear: 'Njaaykat yi gën a jëfandikoo ci {{ CurrentYear }}',
    discoverBestSellingCarsOfYear:
        'Dëggal njaaykat yi gën a jëfandikoo ci {{ CurrentYear }}: Njàngat bu am solo ci jàmmu auto, njaaykat yi gën a jëfandikoo ak jàmmu njaaykat yi am ci elektriki.',
    loanAmount: 'Jëmaleem ngir am mburu',
    carLoanCalculatorDesc:
        'Paré na yéené ci saytu say mooyuka yu ubli, ndimbal gu jar, ak laa dioor. Naka ngir jénd ci néw wala mboq, jógkat bii dina yééné la ci jëmaleem.',
    vehicleTechnicalDocuments: 'Dokument yu Teknike yi Njituka yi',
    vehicleTechnicalDocumentsDesc:
        'Dinañu gis njituka yépp ak dokument yu teknike yi.',
    vehicleName: 'Tur wi Njituka',
    fileSize: 'Sutura fayil',
    modifiedDate: 'Bésu soppi',
    action: 'Jëf',
    downloadDoc: 'Telecharge dokument bi',
    technicalDocs: 'Dokkument yu teknikal',
    dataNotAvailable: 'Dokkument yi amul.',
    documentsAvailable: 'dokkument yi am na',
    downloadError: 'Jaxalul telechaaji',
    failedToDownload:
        'Amna lu moytu ci telechaaji bi. Ndaxte cigënale wala nekkal ci yeneen waay ndimbal.',
    close: 'Tëj',
    priceRangeList: 'Gaari yi {{min}} ba {{max}}',
    comingCarsSubtitle: 'Ci kawar gi, nga gis ay oto yu nekk yu di ñëw ba pare',
    buyComingCars: 'Oto yu ñëw',
    buyAllCars: 'Oto yu bees',
    buyNewCars: 'Oto yu bees',
    incoming: 'Ñëw na',
    referAndEarnPage: {
        title: 'Yëngal te Jëfandikoo',
        hero: {
            title: 'Yëngal te Jëfandikoo ak Auto24',
            desc: 'Léegi nga def ab jëfandikoo yu ñu soxla ab oto ak Auto24 te nga jëfandikoo su neexee su nga ame ab jëfandikoo bu baax. Porogram bi dafa fas a am, dafa ñuul, te amul ab investisimañ bu jëkk. Nga man a jëfandikoo ñu baree ñu nga soxla, nga xam sa jëfandikoo yi, te nga jëfandikoo bopp bu neexee — amul ab limit bu nga man a jëfandikoo.'
        },
        howItWorks: {
            title: 'Naka la ko def',
            desc: 'Yëngal ab ab ñu soxla oto ci Auto24 te nga am ab jëfandikoo su neexee.\n\nAuto24 dafa am ñaar i bopp yu jëfandikoo :',
            planA: {
                title: 'Plan A',
                desc: 'Yëngal ab ab ñu soxla ak ab jëfandikoo bu mat te nga am',
                amount: 'R2,500',
                per: '/ci ab jëfandikoo bu baax'
            },
            planB: {
                title: 'Plan B',
                desc: 'Yëngal ab ab ñu soxla te amul ab jëfandikoo bu mat te nga am',
                amount: 'R1,000',
                per: '/ci ab jëfandikoo bu baax'
            },
            importantInfo: {
                title: 'Benn benn xibaar yu am solo',
                items: [
                    'Faw nga bindu laata nga jëfandikoo ab ab',
                    'Amul ab frais bu bindu',
                    'Man nga jëfandikoo ab ab ñu baree',
                    'Jëfandikoo yi man na ñu def ci internet',
                    'Jëfandikoo yi ñu dafa ko defee su neexee'
                ]
            }
        },
        getStarted: {
            title: 'Naka nga moy tu start ?',
            steps: [
                {
                    title: 'Bindu',
                    desc: 'Bindu ci form bi ci suuf.'
                },
                {
                    title: 'Yónnee Referral',
                    desc: 'Duggal say xibaaru client bi ngay yónnee.'
                },
                {
                    title: 'Nu ngi di ko kontak',
                    desc: 'Auto24 dafay kontak ak client bi referral bi.'
                },
                {
                    title: 'Jot li nga wara jot',
                    desc: 'Jot sa récompense bi ci bi referral bi confirmé.'
                }
            ],
            startReferring: {
                title: 'Tàmbal Referral Bi Tey',
                desc1: 'Féexal say xibaaru ngir nga jot benn xibaaru ak nga tàmbal jot li nga wara jot ak Auto24.',
                desc2: 'Conditions générales yi moy jëfandikoo.'
            }
        }
    },
    financePage: {
        financeHero: {
            title: '<yellow>Finaas</yellow> <green>Moto</green> Sa ak AUTO24',
            desc: 'Finaas moto sa ki ñu atteste ni ngay jëfandikoo ak AUTO24, dafa yomb torop te am na 3 ñu jëm ci:',
            step1: 'Yow mi nga tànn moto sa',
            step2: 'Yow mi nga yebal bépp dëkku ñu la laaj',
            step3: 'Yow mi nga jégg ci yéeme bu bank bi def',
            fastAndSimple: 'Gaaw ak yomb!',
            agent: 'Benna ci ñu ngi liggéey ak finaas ak ñu ngi jàngale ñi mu gëstu ci sa dëkku ak mu la jàngale ci mbooloo mi.'
        },
        whyChooseUs: {
            title: 'Lu Tax Tànn AUTO24',
            featureTitle1: 'Jariñu AUTO24',
            featureDesc1:
                'Nu ngi joxe jariñu ci di jëkk ci wàllu moto yu jëfandikoo ci Afrik, nu defar jariñu bu aada ci at yu bari, ci satisfaksyoŋu kliyaaŋ yi, ak ci di jëkk ci njaboot.',
            featureTitle2: 'Seet bu Jidd',
            featureDesc2:
                'Moto yi nu ngi joxe seet ci 120 ñu jëm ci kàttan, ngir nuy joxe moto yu amul njariñu. Jot ci motër yi, ci kaw suuf, bépp jëmu dafa seet ci ñu ngi xam dëgg ak xam-xam.',
            featureTitle3: 'Soxla Yu Xewoon',
            featureDescItem1:
                'Politisu Yedd ci 5 Ñan: Su sa ñuuloo ak sa jë, politisu yedd ci 5 ñan la mu jox.',
            featureDescItem2:
                'Garanti 6 Weer: Nu ngi joxe garanti 6 weer ci bépp moto yi ngir sa màndarga.',
            featureDescItem3:
                'Pake Asuraŋs 1 At: Tànn ci màndarga ak pake asuraŋs 1 at.',
            featureDescItem4:
                'Pake Njàpp Moto 1 At: Fésal, nu ngi joxe pake njàpp moto ci at bi jëkk.',
            featureTitle4: 'Seet Dëkku',
            featureDesc4:
                'Bépp dëkku ak jariñu moto dafa seet ci kàttan ngir nuy joxe xam-xam ci sa mbooloo.',
            featureTitle5: 'Jë ak Ñaari Tànneef yu Yomb',
            featureDesc5:
                'Nu ngi joxe jë ak ñaari tànneef yu gaaw ak yu amul benn fitna, nuy joxe sa ubaram yomb torop.'
        },
        qualitySection: {
            title: 'Njariñu, Màndarga, ak Jàppale',
            desc: 'AUTO24 du ci di wàllu; dafa am mbooloo bu jàppale làkk wi tax. Nu ngi la soxla ngir nuy joxe yow ci tànn yu am xam-xam, nuy joxe ubaram yu xewoon yu amul ci beneen wàll.',
            desc2: 'Wona yow mi nga jëkk ci jë, walla yow mi nga am xam-xam ci tànn moto, AUTO24 am na lu la joxe. Jot ci nu, njoo wàllu mbooloo yu amul benn.',
            imageAlt: 'Màndarga ak Jàppale'
        },
        whyFinanceSection: {
            title: 'Lu Tax Finaas Sa Moto ak AUTO24',
            desc: 'Nu ngi la joxe ofeeri finaas yu amul njariñu ak di joxe xaalis yu néew ak yedd yu néew.',
            featureTitle1: 'Njariñu yu Ñuul',
            featureDesc1: 'APR Jot 5% (yere)',
            featureTitle2: 'Diisoo yu Yomb',
            featureDesc2: 'Joxe xaalis sa moto ci 12 kese 72 weer',
            featureTitle3: 'Bépp Ci Lign',
            featureDesc3: 'Siyaan bépp sa dëkku ci sa ker'
        },
        ourFinancingPartnerSection: {
            title: 'Ñu Ñu Jàppale ak Finaas',
            desc: 'Ña nga benn ci ñu ñu jàppale ak finaas'
        }
    },
    insureHero: {
        title: '<yellow>Asuraŋs</yellow> <green>Sa Moto</green> ak AUTO24',
        desc: 'Boo jënd moto sa, benn ci ñu jëm ci lu am solo moo di tànn asuraŋs yu ñuul.',
        desc2: 'Wona ak AUTO24 ak ñu ñu jàppale ak WiAssur, amul benn fitna, dafa am yomb ak yoon yu ñuul. Yow mi nga joxe asuraŋs yu ñuul ci yow ak sa moto, ci njariñu yu ñuul.',
        desc3: 'Benn ci ñu ngi liggéey ak asuraŋs ak ñu ngi jàngale ñi mu gëstu ci sa dëkku ak mu la jàngale ci mbooloo mi.'
    },
    // Voetstoots Trade Sale translations
    voetstoots: 'Voetstoots',
    voetstootsTradeSaleTitle: 'Centre Commercial Auto24',
    voetstootsTradeSaleSubtitle:
        'Jénd ay oto yu trok ci prix yu ndaw — amul garanti, amul dellu.',
    voetstootsTradeSaleWarningDetails:
        'Motooy Auto24 Trade Centre di waññiku ni ñu mel, ci kersa, ci joxekaay, wala ci tiim. Ñi nga jënd def lepp ci seen bopp ci xool, yoon wi, ak mbey yu ñu ànd ci à venir.',
    voetstootsTradeSaleList1: 'Jaay voetstoots (ni ko nekk)',
    voetstootsTradeSaleList2:
        'Amul garanti walla garanti yi dinañu jëfandikoo.',
    voetstootsTradeSaleList3: 'Rafles ak tas yi ci njëriñ jëndikat bi.',
    voetstootsTradeSaleList4: 'Amul dellu, dellu xaalis, walla trok.',
    voetstootsTradeSaleList5: 'Sertifika bu yaramu yoon amul.',
    voetstootsTradeSaleList6:
        'Problème yi ñu xam ñu defar, défaut yu nëbb di am.',
    voetstootsTradeSaleLearnMore: 'XAM LII ÑU ÑËW',
    voetstootsTradeSaleCarsTitle: 'Oto yi Jaay',
    voetstootsTradeSaleCarsSubtitle:
        'Ci kawar gi, nga gis ay oto yu nekk yu jaay',
    voetstootsTradeSaleViewAll: 'GIS OTO YÉPP',
    voetstootsTradeSalePageTitle: 'Centre Commercial',
    voetstootsTradeSalePageDesc:
        'Centre Commercial Auto24 dina joxe ay njituka yu trok ci prix yu ndaw Voetstoots, maanaam oto yi ñu jaay leen ak mboolem ay défaut, soo xamul walla soo xam. Garanti, dellu, walla rafles amul, ak jëndikat yi ñu nangoo ak responsabilité bu mat ci njëriñ walla tas yi di ñëw. Lu ñu waxul ci yeneen, njituka yi ñu jaay leen amul sertifika bu yaramu yoon, te naka ay problème yu mag yi ñu xam ñu dinañu defar, problème yu nëbb di am. Jëndikat yi ñu dinañu ñu kontròl oto yi bu baax gannaaw jénd, ak propriété dinañu transfert rekk gannaaw jot peyement bu mat.',
    voetstootsTradeSalePageKeywords:
        'voetstoots, jaay, oto ni ko nekk, njituka yu ndaw, amul garanti',
    // WhatsApp Banner
    whatsappBanner: {
        discover: 'Dëggal',
        exclusive: 'Exklusif',
        deals: 'Jëmmu',
        stayUpdatedWithLatestNews:
            'Dëkk ci xibaar bu bees, ay soppi ak jëmmu yu exklusif',
        offersStraightToWhatsApp: 'jëmmu yooyu ci sa WhatsApp.',
        getLatestCarNewsAmazingTips:
            'Amal xibaar bu bees ci auto, ay conseil bu am solo ak jëmmu WhatsApp yu exklusif. Yéené bu jëkk ngir xam sunu jëmmu yu gën ngir ñu topp sunu chaîne – bul mank lii!',
        joinChannel: 'JOIN CHAÎNE'
    },
    view: 'GIS',
    openPdf: 'UBBI PDF'
};

export default commonWolof;
